// Paths
import { Routes } from '@angular/router';
import { AgentModulePaths, AgentPaths } from 'src/app/constants/routes';

// Guards
import { AgentSessionGuard } from 'src/app/guards/agent-session.guard';

// Components
import { MemberSearchComponent } from 'src/app/components/agent/member/search.component';
import { CounselorMemberLookupHistoryComponent } from 'src/app/components/agent/member/lookup-history.component';
import { CounselorMemberTestMembersComponent } from 'src/app/components/agent/member/test-members.component';
import { CounselorMemberCreateComponent } from 'src/app/components/agent/member/create.component';

import { AgentResourcesBenefitsComponent } from 'src/app/components/agent/resources/benefit.component';
import { AgentResourcesCompanyComponent } from 'src/app/components/agent/resources/company.component';
import { AgentResourcesComplianceComponent } from 'src/app/components/agent/resources/compliance.component';
import { AgentResourcesContactsComponent } from 'src/app/components/agent/resources/contacts.component';

// import { CallLogsComponent } from 'src/app/components/agent/call-log/call-logs.component';
// import { CreateCallLogComponent } from 'src/app/components/agent/call-log/create-call-log.component';

// import { AgentFollowUpOpenComponent } from 'src/app/components/agent/follow-up/follow-up-open.component';
// import { AgentFollowUpCompletedComponent } from 'src/app/components/agent/follow-up/follow-up-completed.component';
// import { FollowUpManagementComponent } from 'src/app/components/agent/follow-up/follow-up-management.component';

import { ReportWizardComponent } from 'src/app/components/agent/reports/report-wizard.component';
import { ReportsTodayComponent } from 'src/app/components/agent/reports/reports-today.component';
import { ReportsHistoryComponent } from 'src/app/components/agent/reports/reports-history.component';

import { AgentsComponent } from 'src/app/components/agent/management/agents.component';
import { AgentCompanyAssignComponent } from 'src/app/components/agent/management/company-assign.component';
import { AgentAssignComponent } from 'src/app/components/agent/management/agent-assign.component';
import { AgentCarrierInfoComponent } from 'src/app/components/agent/management/carrier-info.component';
import { TestServersComponent } from 'src/app/components/agent/management/test-servers.component';
import { ReviewSassComponent } from 'src/app/components/agent/management/review-sass.component';
import { AuthenticatorTestComponent } from 'src/app/components/agent/management/authenticator-test.component';

const AgentMemberComponents = [
    MemberSearchComponent,
    CounselorMemberLookupHistoryComponent,
    CounselorMemberTestMembersComponent,
    CounselorMemberCreateComponent
];

// const AgentCallLogComponents = [
//     CallLogsComponent,
//     CreateCallLogComponent
// ];

// const AgentFollowUpComponents = [
//     AgentFollowUpOpenComponent,
//     AgentFollowUpCompletedComponent,
//     FollowUpManagementComponent
// ];

const AgentResourceComponents = [
    AgentResourcesBenefitsComponent,
    AgentResourcesCompanyComponent,
    AgentResourcesComplianceComponent,
    AgentResourcesContactsComponent
];

const ReportsComponents = [
    ReportWizardComponent,
    ReportsTodayComponent,
    ReportsHistoryComponent
];

const AgentManagementComponents = [
    AgentsComponent,
    AgentCompanyAssignComponent,
    AgentAssignComponent,
    AgentCarrierInfoComponent,
    TestServersComponent,
    ReviewSassComponent,
    AuthenticatorTestComponent
];

// Exports
export const Agent1MemberRoutes: Routes = [
    {
        path: AgentModulePaths.CounselorMember,
        redirectTo: AgentPaths.CounselorMemberLookup,
        pathMatch: 'full',
    },
    {
        path: AgentModulePaths.CounselorMemberLookup,
        component: MemberSearchComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.CounselorMemberLookupHistory,
        component: CounselorMemberLookupHistoryComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.CounselorMemberTestMembers,
        component: CounselorMemberTestMembersComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.CounselorMemberCreate,
        component: CounselorMemberCreateComponent,
        canActivate: [AgentSessionGuard]
    },
];

// export const Agent2CallLogRoutes: Routes = [
//     {
//         path: AgentModulePaths.CallLogs,
//         redirectTo: AgentPaths.CallLogHistory,
//         pathMatch: 'full',
//     },
//     {
//         path: AgentModulePaths.CallLogHistory,
//         component: CallLogsComponent,
//         canActivate: [AgentSessionGuard],
//     },
//     {
//         path: AgentModulePaths.CallLogsCreate,
//         component: CreateCallLogComponent,
//         canActivate: [AgentSessionGuard],
//     },
// ];

// export const Agent3FollowUpsRoutes: Routes = [
//     {
//         path: AgentModulePaths.FollowUps,
//         redirectTo: AgentPaths.FollowUpsOpen,
//         pathMatch: 'full',
//     },
//     {
//         path: AgentModulePaths.FollowUpsOpen,
//         component: AgentFollowUpOpenComponent,
//         canActivate: [AgentSessionGuard]
//     },
//     {
//         path: AgentModulePaths.FollowUpsCompleted,
//         component: AgentFollowUpCompletedComponent,
//         canActivate: [AgentSessionGuard]
//     },
//     {
//         path: AgentModulePaths.FollowUpManagement,
//         component: FollowUpManagementComponent,
//         canActivate: [AgentSessionGuard]
//     },
// ];

export const Agent4ResourcesRoutes: Routes = [
    {
        path: AgentModulePaths.Resources,
        redirectTo: AgentPaths.ResourcesBenefitLevel,
        pathMatch: 'full',
    },
    {
        path: AgentModulePaths.ResourcesBenefitLevel,
        component: AgentResourcesBenefitsComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.ResourcesCompanyLevel,
        component: AgentResourcesCompanyComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.ResourcesCompliance,
        component: AgentResourcesComplianceComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.ResourcesContacts,
        component: AgentResourcesContactsComponent,
        canActivate: [AgentSessionGuard]
    },
];

export const Agent5ReportsRoutes: Routes = [
    {
        path: AgentModulePaths.Reports,
        redirectTo: AgentPaths.ReportsExecute,
        pathMatch: 'full',
    },
    {
        path: AgentModulePaths.ReportsExecute,
        component: ReportWizardComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.ReportsToday,
        component: ReportsTodayComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.ReportsHistory,
        component: ReportsHistoryComponent,
        canActivate: [AgentSessionGuard]
    },
];

export const Agent6AgentsRoutes: Routes = [
    {
        path: AgentModulePaths.Agents,
        redirectTo: AgentPaths.AgentsManage,
        pathMatch: 'full',
    },
    {
        path: AgentModulePaths.AgentsManage,
        component: AgentsComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.AgentsCompanyAssignment,
        component: AgentCompanyAssignComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.AgentsAssignment,
        component: AgentAssignComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.AgentsCarrierInfo,
        component: AgentCarrierInfoComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.AgentsTestServers,
        component: TestServersComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.AgentsReviewSASS,
        component: ReviewSassComponent,
        canActivate: [AgentSessionGuard]
    },
    {
        path: AgentModulePaths.AuthenticatorTest,
        component: AuthenticatorTestComponent,
        canActivate: [AgentSessionGuard]
    },
];

export const AgentComponents = [
    AgentMemberComponents,
    //AgentCallLogComponents,
    AgentResourceComponents,
    //AgentFollowUpComponents,
    ReportsComponents,
    AgentManagementComponents,
];